import { useEffect } from "react";
import { useMap } from "@vis.gl/react-google-maps";
import { useHookstate } from "@hookstate/core";
import { MAP_GLOBAL_STATES } from "globalStore/globalStore";

export const MapInitializer = ({
    mapTypeId,
    setMap,
    setMaps
}) => {
    const { mapsDataGlobalState, mapDataGlobalState } = useHookstate(MAP_GLOBAL_STATES);

    const map = useMap();
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    useEffect(() => {
        if (!map || !window.google?.maps || !window.google.maps.marker) {
            return;
        }

        const maps = window.google.maps;

        map.setOptions({
            disableDefaultUI: true,
            zoomControl: true,
            fullscreenControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            gestureHandling: "greedy",
            scrollwheel: true,
            draggableCursor: "default",
            draggingCursor: "move",
            mapTypeId,

            zoomControlOptions: {
                position: maps.ControlPosition.RIGHT_BOTTOM,
            },

            fullscreenControlOptions: {
                position: isMobile
                    ? maps.ControlPosition.LEFT_BOTTOM
                    : maps.ControlPosition.RIGHT_BOTTOM,
            },
        });

        setMap(map);
        setMaps(maps);
        mapDataGlobalState.set(map);
        mapsDataGlobalState.set(maps);
    }, [map, mapTypeId, isMobile]);

    return null;
};
